import * as ACTION from './constants';
import apiService from '../apiService';
import {processApiRequest} from '../../Common/saga';

export function* fetchDeliveryNotes(action) {
    yield processApiRequest(ACTION.FETCH_DELIVERY_NOTES, () => apiService.getDeliveryNotes(action.payload), action.payload);
}